import { render } from "./CreditInvoice.vue?vue&type=template&id=10b17db3"
import script from "./CreditInvoice.vue?vue&type=script&lang=js"
export * from "./CreditInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__